import { render, staticRenderFns } from "./courseSidebarInt.vue?vue&type=template&id=2027658f&"
import script from "./courseSidebarInt.vue?vue&type=script&lang=js&"
export * from "./courseSidebarInt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports